/**
 * Early boot: apply surface tokens before React paints (pairs with index.html theme class).
 */
import { applySurfaceTokens } from "./applySurfaceTokens";

const stored = localStorage.getItem("theme");
applySurfaceTokens(stored === "dark" ? "dark" : "light");
